import React, { Component } from "react";
import { doLogin } from "../../../actions/authAction";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import logo from "../../../assets/img/brand/lcs_logo.png";
import popop_panduan from "../../../assets/img/popup-panduan.png";
import "../../../scss/_login.scss";
import { Link } from "react-router-dom";
import Select from "react-select";
import Recaptcha from "react-recaptcha";
import {
  SITE_KEY,
  IS_CAPTCHA,
  ID_CONSIGNEE,
  ID_RESELLER,
  ID_SHIPPER,
} from "../../../actions/constant";
import { roleFetchAll } from "../../../actions/roleAction";
import { customParamsFetch } from "actions/ExpiredPiAction";
import "./login.css";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
  LoadCanvasTemplateNoReload,
} from "react-simple-captcha";
// import Keycloak from "keycloak-js";
import { KeycloakProvider, useKeycloak } from "@react-keycloak/web";
import { login, handleCallback, getUser } from "authservice";

const oidcUser = JSON.parse(
  sessionStorage.getItem(
    `oidc.user:https://sso-dev.hubla.dephub.go.id/realms/djpl:sitolaut`
  )
);
// const accessToken = oidcUser.access_token;
// const userProfile = oidcUser.profile;
class Login extends Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false,
      usery_type_id: "",
      isVerified: false,
      message: "",
      userType: [],
      showPassword: false,
      showConfirmPassword: false,
      // isFirstVisit: true, // Melacak apakah ini kunjungan pertama
      // modalOpen: true, // Modal terbuka pertama kali
    };

    this.handleValid = this.handleValid.bind(this);
    this.handleInvalid = this.handleInvalid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.onloadCallback = this.onloadCallback.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    // this.toggleModal = this.toggleModal.bind(this); // Metode untuk toggle modal
    // this.handleLoginSSO = this.handleLoginSSO.bind(this);
  }

  componentDidMount() {
    this.props.roleFetchAll();
    if (window.location.pathname === "/callback") {
      // this.handleLoginCallback();
    }
    // handleCallback()
    //   .then(() => {
    //     getUser().then((user) => {
    //       this.setState({ user });
    //       console.log("User logged in:", user);
    //     });
    //   })
    //   .catch((error) => {
    //     console.error("Login failed:", error);
    //   });
    // loadCaptchaEnginge(6, "#f0f3f5", "black");
    // this.props.customParamStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rolesIsSuccess !== this.props.rolesIsSuccess) {
      if (this.props.roles != null) {
        loadCaptchaEnginge(6, "#f0f3f5", "black");
        this.props.roles.data.forEach((item) => {
          let option = {};
          if (
            item.id.toString() === this.props.maintenancePageData.role &&
            this.props.maintenancePageData.maintenance === true
          ) {
            option = {
              value: item.id,
              label: item.usertype,
            };
            this.setState((prevState) => ({
              userType: prevState.userType.concat(option),
            }));
          } else if (this.props.maintenancePageData.maintenance === false) {
            option = {
              value: item.id,
              label: item.usertype,
            };
            this.setState((prevState) => ({
              userType: prevState.userType.concat(option),
            }));
          }
        });
      }
    }
  }

  // handleLogin = () => {
  //   login();
  // };

  handleLogin = async () => {
    // Jika Anda ingin memulai login SSO
    login(); // Panggil fungsi login untuk memulai proses SSO
  };

  // handleLoginCallback = async () => {
  //   try {
  //     await handleCallback();
  //     const user = await getUser();
  //     if (user) {
  //       console.log("User logged in:", user);
  //       localStorage.setItem("access_token", user.access_token);
  //       this.props.history.push("/dashboard"); // Arahkan pengguna ke halaman utama
  //     }
  //   } catch (error) {
  //     console.error("Login failed:", error);
  //   }
  // };

  onloadCallback() {}

  verifyCallback(response) {
    if (response !== "") {
      this.setState({ isVerified: true });
    }
  }

  selectOption(option) {
    this.setState({ usery_type_id: option.value });
  }

  handleSubmit(event, values) {
    values.usery_type_id = this.state.usery_type_id;

    if (IS_CAPTCHA === "DISABLE") {
      let user_captcha = document.getElementById("user_captcha_input").value;

      if (validateCaptcha(user_captcha) === true) {
        // alert("Captcha Matched");
        loadCaptchaEnginge(6);
        document.getElementById("user_captcha_input").value = "";
        this.props.doLogin(values);
      } else {
        alert("Captcha yang anda masukan salah");
        document.getElementById("user_captcha_input").value = "";
      }
    } else {
      this.props.doLogin(values);
    }
  }

  handleValid() {
    this.setState({ canSubmit: true });
  }

  handleInvalid() {
    this.setState({ canSubmit: false });
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  toggleConfirmPasswordVisibility = () => {
    this.setState((prevState) => ({
      showConfirmPassword: !prevState.showConfirmPassword,
    }));
  };

  // doSubmit = () => {
  //   let user_captcha = document.getElementById("user_captcha_input").value;

  //   if (validateCaptcha(user_captcha) === true) {
  //     alert("Captcha Matched");
  //     loadCaptchaEnginge(6);
  //     document.getElementById("user_captcha_input").value = "";
  //   } else {
  //     alert("Captcha Does Not Match");
  //     document.getElementById("user_captcha_input").value = "";
  //   }
  // };

  // toggleModal() {
  //   this.setState({ modalOpen: !this.state.modalOpen }); // Toggle untuk modal
  // }

  render() {
    // console.log("custom param", this.props);
    // const { modalOpen } = this.state; // Mendestrukturisasi state modalOpen
    if (this.props.isAuthenticated) {
      if (
        localStorage.getItem("tolaut@typeUser") == ID_CONSIGNEE ||
        localStorage.getItem("tolaut@typeUser") == ID_RESELLER ||
        localStorage.getItem("tolaut@typeUser") == ID_SHIPPER
      ) {
        if (
          this.props.isExpired.expired == "false" &&
          this.props.isExpired.status == "0"
        ) {
          return <Redirect to="/expired/need-validate" />;
        } else if (localStorage.getItem("tolaut@status") === "-7") {
          window.alert(
            "Anda perlu melakukan registrasi ulang sebagai shipper! Silakan klik menu Edit Profile."
          );
          // window.location.reload();
          return <Redirect to={"/register-shipper"} />;
        } else {
          return (
            <Redirect
              to={
                this.props.isExpired.expired == "true"
                  ? "/expired/true"
                  : localStorage.getItem("tolaut@typeUser") === "14"
                  ? "/dashboard-leader"
                  : "/dashboard"
              }
            />
          );
        }
      } else {
        if (localStorage.getItem("tolaut@typeUser") === "14") {
          return <Redirect to="/dashboard-leader" />;
        } else {
          return <Redirect to="/dashboard" />;
        }
      }
    }

    const { usery_type_id } = this.state.usery_type_id;
    const userType = this.state.userType;
    return (
      <div className="form-body">
        {/* {this.state.isFirstVisit && (
          <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
            <ModalHeader toggle={this.toggleModal}>
              Selamat Datang di SiTolaut
            </ModalHeader>
            <ModalBody>
              <div className="modal-content">
                <a
                  href="https://drive.google.com/drive/folders/1JOfMXB0epEwAOv2BB_U9fMxl0k_JR-s3"
                  target="_blank" // Membuka link di tab baru
                  rel="noopener noreferrer" // Keamanan tambahan
                >
                  <img
                    src={popop_panduan} // Ganti dengan path gambar panah
                    alt="Petunjuk Panah"
                    style={{
                      width: "100%",
                      height: "auto",
                      marginBottom: "20px",
                    }}
                  />
                </a>
                <p>Klik link "Panduan" untuk petunjuk penggunaan sistem ini.</p>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.toggleModal}>
                Saya Mengerti
              </Button>
            </ModalFooter>
          </Modal>
        )} */}
        <div className="row">
          <div className="img-holder">
            <div className="bg"></div>
            <div className="info-holder">
              <div className="image-center">
                <img src={logo} width="100" height="50" alt="" />
              </div>
              <h3>Sistem Informasi Tol Laut.</h3>
              <p>Access to the most powerfull tool in this application.</p>
            </div>
          </div>
          <div className="form-holder">
            <div className="form-content">
              <div className="form-items">
                <div className="website-logo-inside">
                  <div className="logo">
                    <h1>Login</h1>
                  </div>
                </div>
                {!this.props.maintenancePageData.maintenance && (
                  <div className="page-links">
                    <a href="/login" className="active">
                      Login
                    </a>
                    <Link to={"/register"}>Register</Link>
                    <a
                      target="_blank"
                      href={
                        "https://drive.google.com/drive/folders/1JOfMXB0epEwAOv2BB_U9fMxl0k_JR-s3"
                      }
                    >
                      Panduan
                    </a>
                  </div>
                )}
                {this.props.isLoading && (
                  <div className="alert alert-info alert-login" role="alert">
                    Loading ....
                  </div>
                )}
                {this.props.hasError && (
                  <div className="alert alert-danger alert-login" role="alert">
                    Incorrect username or password, please try again.
                  </div>
                )}
                {this.state.message && (
                  <div className="alert alert-danger alert-login" role="alert">
                    {this.state.message}
                  </div>
                )}

                <AvForm onValidSubmit={this.handleSubmit}>
                  <Select
                    name="usery_type_id"
                    required
                    className="mb-3 jenis-user"
                    placeholder="-- Jenis User --"
                    value={usery_type_id}
                    onChange={this.selectOption}
                    options={userType}
                    // styles={{ zIndex: 2 }}
                    // id="usery_type_id"
                    // inputId="input_usery_type_id"
                    // instanceId="instance_usery_type_id"
                  />

                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-envelope"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <AvInput
                      type="email"
                      name="email"
                      required
                      placeholder="Email"
                      autoComplete="email"
                    />
                  </InputGroup>
                  {/* <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <AvInput
                      type="password"
                      name="password"
                      required
                      placeholder="Password"
                      autoComplete="current-password"
                    />
                  </InputGroup> */}
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <AvInput
                      type={this.state.showPassword ? "text" : "password"}
                      name="password"
                      required
                      placeholder="Password"
                      autoComplete="off"
                      // tag={<Input type="password" />}
                    />
                    <InputGroupAddon addonType="append" className="eye-button">
                      <InputGroupText
                        style={{
                          backgroundColor: "#fff",
                          border: 0,
                        }}
                        onClick={this.togglePasswordVisibility}
                      >
                        <i
                          className={`fa ${
                            this.state.showPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        ></i>
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  {/* {IS_CAPTCHA === "DISABLE" && (
                    <FormGroup>
                      <div>
                        <Recaptcha
                          sitekey={SITE_KEY}
                          render="explicit"
                          verifyCallback={this.verifyCallback}
                          onloadCallback={this.onloadCallback}
                        />
                      </div>
                    </FormGroup>
                  )} */}

                  <div className="mt-3">
                    <div
                      style={{
                        flexDirection: "row-reverse",
                        display: "flex",
                        gap: 10,
                        // paddingLeft: 0,
                      }}
                    >
                      {/* <LoadCanvasTemplate reloadColor="black" /> */}
                      <LoadCanvasTemplateNoReload />
                      <input
                        placeholder="Masukan Captcha"
                        id="user_captcha_input"
                        name="user_captcha_input"
                        type="text"
                      ></input>
                    </div>
                  </div>

                  <div className="form-button">
                    <button id="submit" type="submit" className="ibtn">
                      Login
                    </button>
                    {!this.props.maintenancePageData.maintenance && (
                      <div className="float-right mt-2">
                        <Link to="forgot-password">Lupa Password?</Link>
                      </div>
                    )}
                  </div>
                </AvForm>
                <div className="form-button" style={{ marginTop: -50 }}>
                  <button className="ibtn" onClick={this.handleLogin}>
                    Login menggunakan SSO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    account: state.auth.account,
    isSuccess: state.auth.authLoginSuccess,
    hasError: state.auth.authLoginError,
    isLoading: state.auth.authLoginLoading,
    isAuthenticated: state.auth.isAuthenticated,

    maintenancePageData: state.maintenance.maintenancePageData,

    roles: state.roles.roles,
    rolesIsSuccess: state.roles.roleGetSuccess,

    isExpired: state.auth.isExpired,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doLogin: (cred) => dispatch(doLogin(cred)),
    roleFetchAll: () => dispatch(roleFetchAll()),
    // customParamStatus: () => dispatch(customParamsFetch()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
